import React from 'react'

const IconPlay = ({
  width = 13,
  height = 16,
  fill = 'currentColor',
  responsive = true,
  open = true,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 ${width} ${height}`}
        aria-hidden="true"
        focusable="false"
        className="playIcon"
        {...svgAttributes}>
        <g id="Final" stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
            <g id="Homepage" transform="translate(-648, -362)" fill={fill}>
                <g id="Group-Copy" transform="translate(609, 327)">
                    <polygon id="Triangle" transform="translate(45.6, 43) rotate(-270) translate(-45.6, -43)" points="45.6 37 53.2 49 38 49"/>
                </g>
            </g>
        </g>
    </svg>
  )
}

export default IconPlay
